import styled from 'styled-components';
import { Button, Col } from 'antd';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

export const StepsContainer = styled(Col)`
	border-radius: 1rem;
	background-color: #f8f8f8;
	padding: 2rem 3rem !important;
`;

export const PreviousButton = styled(Button)`
	display: flex;
	font-size: 1rem;
	border-radius: 7px;
	align-items: center;
	padding: 1.15rem 1rem;
	justify-content: center;
	box-shadow: 0px 2px 0px 0px #0000000b;
`;

export const NextButton = styled(Button)`
	display: flex;
	font-size: 1rem;
	border-radius: 7px;
	align-items: center;
	justify-content: center;
	padding: 1.15rem 1.5rem;
	background-color: ${DEFAULT_RISK_RPN_COLOR};
	box-shadow: 0px 2px 0px 0px #0000000b;
`;
